import { Component, OnInit, Input } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'portals-name-avatar',
  template: `<nz-avatar nz-tooltip [nzTooltipTitle]="fullName" class="avatar" [nzText]="avatarName"></nz-avatar>
  `,
  styleUrls: ['./note-avatar.component.less'],
  standalone: true,
  imports: [
    NzAvatarModule,
    NzToolTipModule 
  ]
})
export class NameAvatarComponent implements OnInit {
  @Input() fullName: string;
  constructor() {}

  ngOnInit() {}

  get avatarName() {
    const subNames = this.fullName.split(' ');

    if (subNames.length > 0) {
      return subNames.map(subName => subName.charAt(0).toUpperCase()).join('');
    }

    return '';
  }
}
